// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__380xB","label":"styles_label__35cej"};